import { closeModal } from '@phoenix/helpers/modal-helper';

export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeModal,
  },
};
